import { useCmsFetch } from '~/composables/craft-fetch'
import type { navigateTo } from '#app/composables/router'

type SeoRedirect = {
  to: string
  type: 301 | 302 | 307 | 308 | 410
  site: string | null
  _source?: string
}

export const useSeoRedirect = () => {
  const cmsFetch = useCmsFetch()

  return async (site: string, uri: string): ReturnType<navigateTo> | Promise<false> => {
    /**
     * [DB-748] Pass the path as-is, including any trailing slash: the CMS decides whether to
     * redirect, e.g. from a URL with a trailing slash to the canonical URL without it.
     */
    const redirect: SeoRedirect | null = await cmsFetch(`/api/seo-helper/${site}/find-redirects.json?path=${encodeURIComponent(uri)}`)
    if (!redirect) {
      return false
    }

    return navigateTo(redirect.to, { replace: true, redirectCode: redirect.type, external: true })
  }
}
